//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-param-reassign */

import { mapGetters, mapActions } from 'vuex';
import LinkDevice from './LinkDevice.vue';
import ConnectionCard from './ConnectionCard.vue';
import InlineSpinner from '../../../common/InlineSpinner.vue';
import LiveEventsCard from './LiveEventsCard.vue';

export default {
  components: {
    LinkDevice,
    ConnectionCard,
    InlineSpinner,
    LiveEventsCard,
  },

  data() {
    return {
      garminDevice: this.$container.deviceFactory.create('garmin'),
      suuntoDevice: this.$container.deviceFactory.create('suunto'),
      suuntoV2Device: this.$container.deviceFactory.create('suuntoV2'),
      polarDevice: this.$container.deviceFactory.create('polar'),
      corosDevice: this.$container.deviceFactory.create('coros'),
      appleDevice: this.$container.deviceFactory.create('apple'),
      connections: [],
      courses: [],
      // connections: [
      //   {
      //     member: {
      //       id: '85cbda1e-9102-4dac-b409-096f10d95990',
      //       cohort: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       user: 'cb46d880-8ec6-4908-aabb-898f84fabd31',
      //       permissions: '3',
      //       date_joined: '2019-04-05',
      //       updated_on: '2021-07-27',
      //       deleted_on: null,
      //     },
      //     cohort: {
      //       id: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       tenant: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Brooks Mobile Lab',
      //       status: 'active',
      //       available_permissions: ['0', '1', '2', '3'],
      //       active: true,
      //     },
      //     tenant: {
      //       id: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Brooks Running',
      //     },
      //   },
      //   {
      //     member: {
      //       id: '85cbda1e-9102-4dac-b409-096f10d95990',
      //       cohort: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       user: 'cb46d880-8ec6-4908-aabb-898f84fabd31',
      //       permissions: '3',
      //       date_joined: '2020-12-15',
      //       updated_on: '2021-07-27',
      //       deleted_on: null,
      //     },
      //     cohort: {
      //       id: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       tenant: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: '2020 Brooks 191.4 Challenge',
      //       status: 'active',
      //       available_permissions: ['0', '1', '2', '3'],
      //       active: true,
      //     },
      //     tenant: {
      //       id: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Brooks Running',
      //     },
      //   },
      //   {
      //     member: {
      //       id: '85cbda1e-9102-4dac-b409-096f10d95990',
      //       cohort: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       user: 'cb46d880-8ec6-4908-aabb-898f84fabd31',
      //       permissions: '3',
      //       date_joined: '2020-08-09',
      //       updated_on: '2021-07-27',
      //       deleted_on: null,
      //     },
      //     cohort: {
      //       id: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       tenant: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'UTMB Cardiovascular Study',
      //       status: 'active',
      //       available_permissions: ['0', '1', '2', '3'],
      //       active: true,
      //     },
      //     tenant: {
      //       id: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Mayo Clinic Research',
      //     },
      //   },
      //   {
      //     member: {
      //       id: '85cbda1e-9102-4dac-b409-096f10d95990',
      //       cohort: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       user: 'cb46d880-8ec6-4908-aabb-898f84fabd31',
      //       permissions: '3',
      //       date_joined: '2020-07-09',
      //       updated_on: '2021-07-27',
      //       deleted_on: null,
      //     },
      //     cohort: {
      //       id: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       tenant: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Platinum PT - Hopkinton, MA',
      //       status: 'active',
      //       available_permissions: ['0', '1', '2', '3'],
      //       active: true,
      //     },
      //     tenant: {
      //       id: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Platinum Physical Therapy',
      //     },
      //   },
      //   {
      //     member: {
      //       id: '85cbda1e-9102-4dac-b409-096f10d95990',
      //       cohort: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       user: 'cb46d880-8ec6-4908-aabb-898f84fabd31',
      //       permissions: '3',
      //       date_joined: '2021-02-14',
      //       updated_on: '2021-07-27',
      //       deleted_on: null,
      //     },
      //     cohort: {
      //       id: 'b552eb4e-795c-4a85-8a91-ec5d4743b62f',
      //       tenant: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Connected Training Log',
      //       status: 'active',
      //       available_permissions: ['0', '1', '2', '3'],
      //       active: true,
      //     },
      //     tenant: {
      //       id: '4ea3f7d9-79d5-4684-86ec-14365b7fe914',
      //       name: 'Coach Krissy Moehl',
      //     },
      //   },
      // ],
      // courses: [
      //   {
      //     id: 'xyz',
      //     event_id: 'test_event1',
      //     course: 'course_abc123',
      //     start_date: '2021-04-22T08:37:44.954670',
      //     end_date: '2021-07-31T08:37:44.954680',
      //     registration_timestamp: '2021-04-15T08:38:28.189012',
      //     slug: '2021-LYfvTV',
      //     bib_number: '26',
      //     course_name: '508 Mile Yosemite Adventure',
      //     event_name: 'Yosemite National Park Challenge',
      //   },
      //   {
      //     id: 'xyz',
      //     event_id: 'test_event2',
      //     course: 'course_abc1234',
      //     start_date: '2021-07-25T08:38:28.189012',
      //     end_date: '2021-10-01T08:38:28.189021',
      //     registration_timestamp: '2021-07-20T08:38:28.189012',
      //     slug: '2021-fF3FMY',
      //     bib_number: '124',
      //     course_name: 'Half a Hardrock (56.6 miles)',
      //     event_name: 'Hardrock 100',
      //   },
      // ],
      tenants: null,
      events: null,
      loading: false,
    };
  },

  props: {
    enabled: {
      type: Object,
      default: () => ({
        devices: {
          garmin: true,
          suunto: true,
          suuntoV2: true,
          polar: true,
          coros: true,
          apple: true,
        },
        sharing: true,
        leaderboards: true,
      }),
    },
    origin: {
      type: String,
    },
  },

  async mounted() {
    await this.initialize();
    await this.fetchCohortMembers();
    await this.fetchMemberCourses();
  },

  methods: {
    ...mapActions(['initialize']),
    mapTenants() {
      this.tenants = this.connections.reduce((acc, connection) => {
        if (connection.member.deleted_on) return acc;
        const payload = {
          id: connection.member.id,
          permissions: connection.member.permissions,
          cohortName: connection.cohort.name,
          availablePermissions: connection.cohort.available_permissions.reverse(),
          dateJoined: connection.member.date_joined,
        };
        if (acc[connection.tenant.name]) {
          acc[connection.tenant.name].push(payload);
        } else {
          acc[connection.tenant.name] = [payload];
        }
        return acc;
      }, {});
    },

    mapEvents() {
      this.events = this.courses.reduce((acc, event) => {
        const coursePayload = {
          course: event.course,
          courseName: event.course_name,
          bibNumber: event.bib_number,
          registrationTimestamp: event.registration_timestamp.slice(0, 10),
        };
        const eventPayload = {
          id: event.id,
          eventId: event.event_id,
          eventName: event.event_name,
          startDate: event.start_date.slice(0, 10),
          endDate: event.end_date.slice(0, 10),
          slug: event.slug,
        };
        if (acc[event.event_id]) {
          acc[event.event_id].courses.push(coursePayload);
        } else {
          acc[event.event_id] = {
            courses: [coursePayload],
            ...eventPayload,
          };
        }
        return acc;
      }, {});
    },

    async fetchCohortMembers() {
      try {
        const { data } = await this.$api.listCohortMembers(
          this.loggedInMember.memberId,
        );
        this.connections = data.filter(connection => connection.member.permissions !== 0 && connection.member.permissions !== '0');
        this.mapTenants();
      } catch (error) {
        console.log(error);
      }
    },

    async fetchMemberCourses() {
      try {
        const { data } = await this.$api.listMemberEvents(
          this.loggedInMember.memberId,
        );
        const currentTime = new Date();
        this.courses = data.filter(
          event => currentTime <= new Date(event.end_date),
        );
        this.mapEvents();
      } catch (error) {
        console.log(error);
      }
    },

    async onUpdate() {
      try {
        await this.fetchCohortMembers();
        await this.fetchMemberCourses();
      } catch (error) {
        console.log(error);
      }
    },
  },

  computed: {
    ...mapGetters(['loggedInMember']),
  },
};
